import type { HttpClient } from '../http';
import { unwrap, type ApiEnvelope } from '../envelope';
import type { PlatformSettingView } from '../types/domain';

export function platformSettingsEndpoints(http: HttpClient) {
  return {
    get: () => http.get<ApiEnvelope<PlatformSettingView[]>>('/v1/platform/settings').then(unwrap),
    update: (updates: Record<string, string>) =>
      http.put<ApiEnvelope<PlatformSettingView[]>>('/v1/platform/settings', updates).then(unwrap),
  };
}
export type PlatformSettingsEndpoints = ReturnType<typeof platformSettingsEndpoints>;
